module.exports = __webpack_public_path__ + "static/media/sign-in-girl.3bf0cf85.png";